import { useState, useContext } from "react";
import Instance from "../../Services/Instance";
import config from "../../Services/config.js";
import SideBar from "../../Layouts/SideBar";
import "../../Assets/Styles/Products.css";
import "../../Assets/Styles/Licenses.css";
import { DataContext } from '../../Services/DataContext.js';

function NewLicense() {
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [isImporting, setIsImporting] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [formData, setFormData] = useState({
        productTypeSmart: "",
        key: "",
        status: "available",
        creationDate: Date.now(),
        productCategory: "",
        productName: "",
    
    });
    const { productCategory, productTypeSmart, productName } = formData;
    const { categories } = useContext(DataContext);

    const handleInputChange = (e) => {
        setFormData({
            ...formData, [e.target.name]: e.target.value
        });
    };

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
            setError("Veuillez sélectionner un fichier Excel (.xlsx ou .xls)");
            e.target.value = '';
            return;
        }

        setSelectedFile(file);
        setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (selectedFile) {
            setIsImporting(true);
            setError("");
            setSuccessMessage("");

            const uploadData = new FormData();
            uploadData.append('file', selectedFile);
            uploadData.append('productCategory', formData.productCategory);
            uploadData.append('productName', formData.productName);
            uploadData.append('productType', formData.productType);
            uploadData.append('productTypeSmart', formData.productTypeSmart);
            uploadData.append('number', formData.number);
            uploadData.append('status', formData.status);

            try {
                const response = await Instance.post(`${config.api_url}/new-license`, uploadData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                setSuccessMessage(response.data.message || `Import réussi: ${response.data.summary.inserted} licences créées`);
                
                setTimeout(() => {
                    window.location = "/dashboard/Licenses";
                }, 2000);
            } catch (error) {
                console.error("Erreur lors de l'import:", error);
                setError(error.response?.data?.message || "Erreur lors de l'import du fichier");
            } finally {
                setIsImporting(false);
            }
        } else {
            try {
                await Instance.post(`${config.api_url}/new-license`, formData);
                window.location = "/dashboard/Licenses";
            } catch (error) {
                console.error("Erreur lors de l'ajout:", error);
                setError(error.response?.data?.message || "Erreur lors de l'ajout");
            }
        }
    };

    return (
        <div className='new-license-page'>
            <SideBar />
            <div className="new-license-container">
                <div className="new-license-header">
                    <h2>Gestion des Licences</h2>
                    <p>Ajouter une ou plusieurs licences à votre catalogue</p>
                </div>

                <form onSubmit={handleSubmit} className="new-license-form" encType="multipart/form-data">
                    <div className="license-form-grid">
                        {/* Catégorie */}
                        <div className="form-group">
                            <label htmlFor="productCategory">Catégorie *</label>
                            <select
                                id="productCategory"
                                value={productCategory}
                                name="productCategory"
                                onChange={handleInputChange}
                                required
                                className="form-select"
                            >
                                <option value="">Sélectionner une catégorie</option>
                                {categories && Array.isArray(categories) && categories.map((item, index) => (
                                    <option key={index} value={item.categoryName}>{item.categoryName}</option>
                                ))}
                            </select>
                        </div>

                        {/* Produit */}
                        <div className="form-group">
                            <label htmlFor="productName">Produit *</label>
                            <select
                                id="productName"
                                value={productName}
                                name="productName"
                                onChange={handleInputChange}
                                required
                                disabled={!productCategory}
                                className="form-select"
                            >
                                <option value="">Sélectionner un produit</option>
                                {productCategory && categories && Array.isArray(categories) &&
                                    categories
                                        .find((item) => item.categoryName === productCategory)
                                        ?.productsName.map((product, index) => (
                                            <option key={index} value={product}>{product}</option>
                                        ))}
                            </select>
                        </div>
                        
                        {/* Type de produit */}
                       

                        {/* Netflix type */}
                       

                        {/* Numéro */}
                        
                    </div>

                    {/* Section Key avec upload */}
                    <div className="license-key-section">
                        <label>Clé de licence *</label>
                        
                        <div className="key-input-wrapper">
                            <textarea 
                                name="key" 
                                className="form-textarea" 
                                value={formData.key} 
                                onChange={handleInputChange} 
                                placeholder="Saisir UNE clé manuellement..."
                                required={!selectedFile}
                                disabled={selectedFile}
                                rows="5"
                            />
                            
                            <div className="file-upload-divider">
                                <span className="divider-text">OU</span>
                            </div>
                            
                            <div className="file-upload-zone">
                                <input
                                    id="key-file-upload"
                                    type="file"
                                    accept=".xlsx,.xls"
                                    onChange={handleFileSelect}
                                    disabled={isImporting}
                                    className="file-input-hidden"
                                />
                                <label 
                                    htmlFor="key-file-upload" 
                                    className={`file-upload-btn ${isImporting ? 'disabled' : ''}`}
                                >
                                    <span className="upload-icon">📁</span>
                                    <span>{isImporting ? 'Import en cours...' : 'Importer plusieurs clés (Excel)'}</span>
                                </label>
                                
                                {selectedFile && (
                                    <div className="file-selected">
                                        <span className="file-icon">✅</span>
                                        <span className="file-name">{selectedFile.name}</span>
                                    </div>
                                )}
                            </div>
                            
                            <p className="helper-text">
                                💡 Vous pouvez saisir une clé manuellement ou uploader un fichier Excel avec une colonne "key"
                            </p>

                            {successMessage && (
                                <div className="success-message">
                                    <span className="success-icon">✅</span>
                                    <span>{successMessage}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="form-actions">
                        <button 
                            type="submit" 
                            className="btn-submit"
                            disabled={isImporting}
                        >
                            {isImporting ? (
                                <>
                                    <span className="spinner"></span>
                                    Import en cours...
                                </>
                            ) : selectedFile ? (
                                '✨ Créer les licences'
                            ) : (
                                '➕ Ajouter la licence'
                            )}
                        </button>
                    </div>
                </form>
            </div>
            
            {error && (
                <div className="error-toast">
                    <span className="error-icon">⚠️</span>
                    <span>{error}</span>
                </div>
            )}
        </div>
    );
}

export default NewLicense;